
import { defineComponent } from "vue";
import { store } from "@/store";

export default defineComponent({
  components: {},
  props: {
    processId: {
      type: String,
      required: true,
    },
  },
  emits: ["reload"],
  data() {
    return {
      submitted: false,
      loading: false,
      name: "",
    };
  },
  computed: {
    type: function () {
      return store.getters["settingsProcesses/getSubTypes"].find((t: any) => t.processId == this.processId);
    },
    types: function () {
      return store.getters["settingsProcesses/getSubTypes"];
    },
  },
  watch: {
    type: function () {
      this.name = "";
    },
  },
  mounted() {
    this.name = "";
  },
  methods: {
    submit: async function () {
      this.submitted = true;

      store.dispatch("settingsProcesses/deleteSubProcess", this.processId);

      this.submitted = false;
      this.name = "";

      const el = this.$refs["closeBtn"] as any;
      el.click();
    },
  },
});
